import { React, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import Switch from "@mui/material/Switch";
import { sidebarReducer } from "../../Redux/store";
import { useDispatch } from "react-redux";
import clear from "../../images/Clear.png";
import "./SalesOrder.scss";
import axios from "axios";
import {
  SuccessAlert,
  FailureAlert,
} from "../../components/Alert_msg/alert_msg";
import moment from 'moment';

import CompanyLogo from "../../images/Ellipse.svg";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function Uploadbundle() {

  const dispatch = useDispatch();

  const navigate = useNavigate();

  
  const handleCreateNewOrderClick = () => {

    navigate("/CreateOrder");
  };
  useEffect(() => {

    getOrdersList();

  }, []);
  const [orderList, setOrderList] = useState([[]]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const getOrdersList = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        '/v1/orderdetails/AllOrders', {
        headers: {
          'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
        }
      }
      );

      const data = response.data.data;
       
      if (response.status === 200) {

        data.sort((a, b) => a.te_ordernumber - b.te_ordernumber);
        setOrderList(data);
        // console.log("orderList",orderList.length)
       

      } else {
        console.error("Invalid server response format:", data);
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return moment(date).format('DD-MMM-YYYY');
  };

  const handleEditOrderClick = (ordernumber,orderid) => {
    navigate(`/CreateOrder/?orderid=`+orderid);
  };
  return (
    <div className="scrollalign">
      <div className=" sale-container" >
        <div className="d-flex " style={{ marginBottom: "30px" }}>
          <h5 style={{ marginRight: "auto", fontSize: "35px"}}>Sales order</h5>
          <button className="create-button" style={{ marginRight: "10px" }}
            onClick={handleCreateNewOrderClick}>Create New Order</button>
        </div>
        <div className=" p-0 m-0">
          <div className="License-table">
            <div className="heading">Order List</div>
            <div className="License-design"  >
             
                <table className="table-data">
                  <thead className="License-table-head">
                    <tr>
                      <th>Ord No</th>
                      <th>Invoice No</th>
                      <th>Order Date</th>
                      <th>Company</th>
                      <th>Customer</th>
                      <th>Software</th>
                      <th>License Key</th>
                      <th>Technician In Charge</th>
                    </tr>
                  </thead>
                  {isLoading ? (
            <div>
              <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", margin: "100px" }}>
                <CircularProgress color="inherit" />
              </Box>
            </div>
          ) : (
                  <tbody className="License-table-body">
                 
                    {orderList && orderList.length > 0 ? (
                      orderList.map((order) => (
                         <tr key={order.te_ordernumber}>
                          <td 
                          //  style={{ textDecoration: "underline",cursor:"pointer" }} 
                          // onClick={() => handleEditOrderClick(order.te_ordernumber, order.te_orderid)}
                          >
                            {order.te_ordernumber}
                          </td>
                          <td >
                           <div className="invoice-number"  title={order.te_invoicerefno}> {order.te_invoicerefno}</div>
                            </td>
                          <td>{formatDate(order.te_orderdate)}</td>
                          <td>{order.master_company ? order.master_company.te_companyname : ''}</td>
                          <td>{order.master_company ? order.master_company.te_customername : ''}</td>
                          <td>{order.te_software}</td>
                          <td>{order.te_lmsid}</td>
                          <td>{order.te_ordercreatedby ? order.te_ordercreatedby : ''}</td>
                        </tr>
                      ))
                    ) : (
                      <tr >
                        <td style={{ textAlign: "center", color: "#B6094C" }}>No order found</td>
                      </tr>
                    )}
              
                  </tbody>
                      )}
                </table>
           
            </div>
          </div>
        </div>
      </div>



      <SuccessAlert />
      <FailureAlert />
    </div>
  );
}

export default Uploadbundle;
